import React , {Component} from 'react'
import { Button , Table, Row, Col } from 'antd'




class SalesDetails extends Component{

  


    data = [
        {
            "type": "Total Sales",
            "amount" : 2000000.00
        },
        {
            "type": "Total Collection",
            "amount" : 4000000.00
        }
    ]



    columns = [
        {
            key: 1,
            dataIndex : "type",
            title : "Type"
        },
        {
            key:2,
            dataIndex: "amount",
            title : "Amount"
        }
    ]



    render(){
        return(
            <div>
                <h3>Sales Data</h3>
                    <Row>
                        <Table pagination={false} columns={this.columns} dataSource={this.data}></Table>
                    </Row>
                 
                </div>
        )
            
    }
}

export default SalesDetails;